// extracted by mini-css-extract-plugin
export default {"component":"P7S3-"};